export default {
  PaletteFooter: {
    backgroundColor: "white",
    height: "4vh",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    fontWeight: "500"
  },
  emoji: {
    fontSize: "1rem",
    margin: "0.5rem"
  }
}